/* eslint-disable react/prop-types */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/sort-comp */
import React from 'react';

import Button from '@/components/button/Button';
import {createNewJsonObject} from '@/libs/appHelper';
import {consoleLog} from '@/libs/consoleHelper';

import './SequenceTypeUpdate.less';

export function GenerateSequenceSelector(
  sequences,
  selectedSequenceId,
  oldSequenceType,
  onChangeSequenceType,
  className = '',
) {
  const buttonList = [];
  consoleLog('GenerateSequenceSelector', sequences);
  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  for (const prop in sequences) {
    sequences[prop].active = false;
    buttonList.push(sequences[prop]);
  }
  return (
    <SequenceSelector
      buttonList={buttonList}
      selectedSequenceId={selectedSequenceId}
      oldSequenceType={oldSequenceType}
      onChangeSequenceType={onChangeSequenceType}
      className={className}
    />
  );
}

export class SequenceSelector extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sequences: [],
    };
  }

  onClick = (e) => {
    const selectedSequences = e.currentTarget.id;
    this.setState({
      sequences: this.updateActiveSequence(this.state.sequences, selectedSequences),
    });
  };

  componentDidMount() {
    this.setState({
      sequences: this.updateActiveSequence(this.props.buttonList, this.props.oldSequenceType),
    });
  }

  updateActiveSequence = (sequences, selectedSequences) => {
    const localSequence = createNewJsonObject(sequences);
    for (let i = 0; i < localSequence.length; i++) {
      if (localSequence[i].value === selectedSequences) {
        localSequence[i].active = true;
        this.props.onChangeSequenceType(selectedSequences, this.props.selectedSequenceId, this.props.oldSequenceType);
      } else {
        localSequence[i].active = false;
      }
    }
    return localSequence;
  };

  render() {
    const {sequences} = this.state;
    const {className} = this.props;

    return (
      <div className={`sequence-parent ${className || ''}`}>
        {sequences.map((sequence) => (
          <Button
            className={sequence.active ? 'sequence-type-button active' : 'sequence-type-button unActive'}
            key={sequence.value}
            id={sequence.value}
            onClick={this.onClick}
            label={sequence.label}
          />
        ))}
      </div>
    );
  }
}
